const footerNav = [
  {
    title: '数字颜色频道',
    links: ['红桃视频', '小蓝视频', '黑桃视频', '91视频', '97视频', '久久视频'],
  },
  {
    title: '快速导航',
    links: ['热门话题', '平台特色', '焦点专题', '频道索引', '热度榜单'],
  },
  {
    title: '相关推荐',
    links: ['梅花视频', '白桃视频', '绿萝视频', '橙子视频', '数字颜色系列'],
  },
];

export default function Footer() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navHrefs: Record<string, string> = {
    '热门话题': '#topics',
    '平台特色': '#features',
    '焦点专题': '#carousel',
    '频道索引': '#index',
    '热度榜单': '#ranking',
  };

  return (
    <footer id="footer" className="relative bg-background-900 border-t border-background-700/30">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-heading text-primary-400 tracking-wider">妖精视频</span>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              妖精视频🌟数字颜色系列综合平台，汇聚红桃视频、小蓝视频、黑桃视频、91视频、97视频、久久视频等特色频道，提供高清免费在线观看，即点即播不缓冲。
            </p>
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-medium text-foreground-300 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => {
                  const href = navHrefs[link];
                  if (href) {
                    return (
                      <li key={link}>
                        <a
                          href={href}
                          onClick={(e) => { e.preventDefault(); handleClick(href); }}
                          className="text-sm text-foreground-600 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                        >
                          {link}
                        </a>
                      </li>
                    );
                  }
                  return (
                    <li key={link}>
                      <span className="text-sm text-foreground-600">
                        {link}
                      </span>
                    </li>
                  );
                })}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/30">
          <div className="mb-6">
            <h4 className="text-sm font-medium text-foreground-400 mb-3">合作伙伴</h4>
            <p className="text-xs text-foreground-700">合作伙伴信息即将上线，敬请期待</p>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-700">
              &copy; {new Date().getFullYear()} 妖精视频 - 数字颜色系列在线平台。本站内容仅供学习交流，请支持正版。
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-700">
              <span>服务条款</span>
              <span>隐私政策</span>
              <span>DMCA</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}